import { Variants } from 'framer-motion'

const topCarouselVariants: Variants = {
  enter: {
    x: '100%',
  },
  center: {
    x: 0,
  },
  exit: {
    x: '-100%',
  },
}

const bottomLeftCarouselVariants: Variants = {
  enter: {
    y: '-100%',
  },
  center: {
    y: 0,
  },
  exit: {
    y: '100%',
  },
}

const bottomRightCarouselVariants: Variants = {
  enter: {
    y: '100%',
  },
  center: {
    y: 0,
  },
  exit: {
    y: '-100%',
  },
}

export const animations = {
  top: topCarouselVariants,
  bottomLeft: bottomLeftCarouselVariants,
  bottomRight: bottomRightCarouselVariants,
}

export type VariantName = keyof typeof animations
